class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[name="q"]');
    this.predictiveSearchResults = this.querySelector('[data-ref="predictive-search"]');

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.hide();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(Theme.routes.predictive_search_url + `?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=product,collection,page,article`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.hide();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
        // Produits réservés à un espace (tags espace-pro / espace-particulier) : retirés AVANT affichage
        if (window.pfFilterBySpace) window.pfFilterBySpace(section);
        this.predictiveSearchResults.innerHTML = section.innerHTML;
        this.show();
      })
      .catch((error) => {
        this.hide();
        throw error;
      });
  }

  show() {
    this.predictiveSearchResults.style.display = 'block';
  }

  hide() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

/*
  Filtre par espace (Particulier / Professionnel) pour la recherche.
  - Produit tagué "espace-pro"         : visible uniquement si pf_space === 'professionnel'
  - Produit tagué "espace-particulier" : visible uniquement si l'espace n'est PAS professionnel
    (espace particulier, ou aucun espace choisi)
  Les éléments concernés portent data-pf-espace="pro" ou "particulier".
*/
window.pfFilterBySpace = function (root) {
  var space = null;
  try { space = localStorage.getItem('pf_space'); } catch (e) {}
  var isPro = space === 'professionnel';
  (root || document).querySelectorAll('[data-pf-espace]').forEach(function (el) {
    var target = el.getAttribute('data-pf-espace');
    var visible = target === 'pro' ? isPro : !isPro;
    if (visible) {
      el.removeAttribute('hidden');
    } else {
      el.remove();
    }
  });
  // Section "Produits" vide après filtrage : on la retire
  (root || document).querySelectorAll('.predictive-search__section').forEach(function (s) {
    var grid = s.querySelector('.predictive-search__grid');
    if (grid && !grid.children.length) s.remove();
  });
};

customElements.define('predictive-search', PredictiveSearch);
